import React from 'react';

// Design System "Technical Precision"
// Chip = fondo tinte + borde del mismo tono + texto oscuro. Radio 4px, 11px.
export const TINT = {
  success: { bg: '#DCFCE7', border: '#BBF7D0', color: '#166534' },
  warning: { bg: '#FEF9C3', border: '#FEF08A', color: '#854D0E' },
  danger:  { bg: '#FEE2E2', border: '#FECACA', color: '#991B1B' },
  info:    { bg: '#DBEAFE', border: '#BFDBFE', color: '#1E40AF' },
  violet:  { bg: '#EDE9FE', border: '#DDD6FE', color: '#5B21B6' },
  neutral: { bg: '#F1F5F9', border: '#E2E8F0', color: '#475569' },
};

const STATUS_MAP = {
  active:      { ...TINT.success, label: 'Activo' },
  inactive:    { ...TINT.danger,  label: 'Inactivo' },
  suspended:   { ...TINT.warning, label: 'Suspendido' },
  deleted:     { ...TINT.danger,  label: 'Eliminado' },
  draft:       { ...TINT.neutral, label: 'Borrador' },
  published:   { ...TINT.info,    label: 'Publicada' },
  scheduled:   { ...TINT.violet,  label: 'Programada' },
  located:     { ...TINT.success, label: 'Ubicado' },
  unlocated:   { ...TINT.warning, label: 'Sin ubicación' },
  pending:     { ...TINT.warning, label: 'Pendiente' },
  onsale:      { ...TINT.info,    label: 'En oferta' },
  completed:   { ...TINT.success, label: 'Completada' },
  boarding:    { ...TINT.info,    label: 'Abordando' },
  in_transit:  { ...TINT.info,    label: 'En tránsito' },
  delivering:  { ...TINT.violet,  label: 'Entregando' },
  cancelled:   { ...TINT.danger,  label: 'Cancelada' },
  incomplete:  { ...TINT.warning, label: 'Incompleta' },
};

export function StatusBadge({ value, label, tone, bg, color, border }) {
  const p = (tone && TINT[tone] && { ...TINT[tone], label: STATUS_MAP[value]?.label })
    || STATUS_MAP[value]
    || { ...TINT.neutral, label: value || '-' };

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      padding: '1px 8px', borderRadius: 4,
      background: bg || p.bg,
      color: color || p.color,
      border: `1px solid ${border || p.border}`,
      fontSize: '11px', lineHeight: '16px', fontWeight: 500,
      whiteSpace: 'nowrap',
      fontFamily: 'inherit',
    }}>
      {label || p.label}
    </span>
  );
}
